import { Component, OnInit, Inject } from '@angular/core';
import { CommonService } from '../../services';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-software',
  templateUrl: './confirm-software.component.html',
  styleUrls: ['./confirm-software.component.css']
})
export class ConfirmSoftwareComponent implements OnInit {

  softwareSubscriptionPoReference: string;
  confirmChecked: boolean = false;
  constructor(
    public commonService: CommonService,
    public dialogRef: MatDialogRef<ConfirmSoftwareComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
  }

  continueSaveSoftware(): void{
    if(this.softwareSubscriptionPoReference){
      this.dialogRef.close(this.softwareSubscriptionPoReference);
    }
    else{
      this.commonService.showError(".poReference", "Po reference can not be empty", "right");
    }
  }
  checkConfirmBox() {
    this.confirmChecked = !this.confirmChecked;
  }

  onNoClick(): void{
    this.dialogRef.close();
  }

}
